var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelicopters(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 15.18C31.0295 15.18 29.8195 16.39 29.8195 17.88V23.73H22.1695V17.88C22.1695 16.39 20.9595 15.18 19.4695 15.18C17.9795 15.18 16.7695 16.39 16.7695 17.88V34.97C16.7695 36.46 17.9795 37.67 19.4695 37.67C20.9595 37.67 22.1695 36.46 22.1695 34.97V29.12H29.8195V34.97C29.8195 36.46 31.0295 37.67 32.5195 37.67C34.0095 37.67 35.2195 36.46 35.2195 34.97V17.88C35.2195 16.39 34.0095 15.18 32.5195 15.18Z",
    fill: "#FFCF00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1.42999C12.19 1.42999 1 12.62 1 26.43C1 40.24 12.19 51.43 26 51.43C39.81 51.43 51 40.24 51 26.43C51 12.62 39.81 1.42999 26 1.42999ZM26 46.29C15.03 46.29 6.14 37.4 6.14 26.43C6.14 15.46 15.03 6.55999 26 6.55999C36.97 6.55999 45.86 15.45 45.86 26.42C45.86 37.39 36.97 46.29 26 46.29Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 1.42999C12.19 1.42999 1 12.62 1 26.43C1 40.24 12.19 51.43 26 51.43C39.81 51.43 51 40.24 51 26.43C51 12.62 39.81 1.42999 26 1.42999ZM26 46.29C15.03 46.29 6.14 37.4 6.14 26.43C6.14 15.46 15.03 6.55999 26 6.55999C36.97 6.55999 45.86 15.45 45.86 26.42C45.86 37.39 36.97 46.29 26 46.29Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5195 15.18C31.0295 15.18 29.8195 16.39 29.8195 17.88V23.73H22.1695V17.88C22.1695 16.39 20.9595 15.18 19.4695 15.18C17.9795 15.18 16.7695 16.39 16.7695 17.88V34.97C16.7695 36.46 17.9795 37.67 19.4695 37.67C20.9595 37.67 22.1695 36.46 22.1695 34.97V29.12H29.8195V34.97C29.8195 36.46 31.0295 37.67 32.5195 37.67C34.0095 37.67 35.2195 36.46 35.2195 34.97V17.88C35.2195 16.39 34.0095 15.18 32.5195 15.18Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelicopters);
export default __webpack_public_path__ + "static/media/Helicopters.e4b3d38edc159ff58645aba3ab195cb2.svg";
export { ForwardRef as ReactComponent };